import styled from 'styled-components';

export const ModalWrapper = styled.div`
  position: absolute;
  width: 514px;
  height: 226px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 26px; 
  padding: 16px 32px 24px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    width: 90%;
    height: auto;
    padding: 16px;
  }

  @media (max-width: 480px) {
    width: 95%;
    height: auto;
    padding: 30px;
    border-radius: 16px;
  }
`;

export const ModalDescription = styled.p`
  font-family: Mangueira;
  font-size: 24.05px;
  line-height: 40.17px;
  text-align: center;
  font-weight: 600;
  color: rgb(0, 15, 255);
`;
